import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetChatBalanceHistory = (queryBody) => {
  const select = useCallback((response) => {
    return response.data?.data ?? { error: response.data?.error ?? null };
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/balancehistory",
      data: queryBody,
    },
    {
      queryKey: ["chat_balance_history", queryBody],
      select,
      refetchOnWindowFocus: false,
    },
  );

  return response;
};
